import { render, staticRenderFns } from "./BasicProfile.vue?vue&type=template&id=364b6fce&scoped=true"
import script from "./BasicProfile.vue?vue&type=script&lang=js"
export * from "./BasicProfile.vue?vue&type=script&lang=js"
import style0 from "./BasicProfile.vue?vue&type=style&index=0&id=364b6fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b6fce",
  null
  
)

export default component.exports